import { Component, Input } from '@angular/core';
import { AnnualStatementRecord } from "@models/annual-statements/annual-statement-record";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-ag-debt-status',
  standalone: true,
  templateUrl: 'ag-debt-status.component.html',
  styleUrl: 'ag-debt-status.component.scss'
})
export class AgDebtStatusComponent implements ICellRendererAngularComp {
  @Input() value = false;

  agInit(params: ICellRendererParams<AnnualStatementRecord, boolean>): void {
    this.updateCell(params);
  }

  refresh(params: ICellRendererParams<AnnualStatementRecord, boolean>): boolean {
    return this.updateCell(params);
  }

  updateCell(params: ICellRendererParams<AnnualStatementRecord, boolean>): boolean {
    this.value = params.value ?? false;
    return true;
  }
}
